import FormValidator from '@/js/plugins/formValidator'

const main = () => {
    if(!document.querySelector('#page-user-account-edit')) return;

    // パスワード未設定のユーザーは、Googleで本人確認するまで変更フォームを表示しない
    if (document.querySelector('#input-email-form form')) {
        const emailFormValidator = new FormValidator({
            renderAreaSelector: '#input-email-form',
            renderErrorCnt: false,
            renderConfirmMessage: true,
            renderErrorPosition: 'outer',
        });
    }

    const passwordFormValidator = new FormValidator({
        renderAreaSelector: '#input-password-form',
        renderErrorCnt: false,
        renderConfirmMessage: true,
        renderErrorPosition: 'outer',
    });

    document.querySelectorAll('button[data-related]').forEach((button) => {
        button.addEventListener('click', (e) => {
            e.preventDefault();
            const targetName = button.getAttribute('data-related');
            const targetObj = document.querySelector(`.item-group[data-group-name="${targetName}"]`);
            targetObj.querySelector('.show-switch').checked = !targetObj.querySelector('.show-switch').checked;
            targetObj.querySelectorAll('.input-check-container').forEach((input) => {
                if(input.classList.contains('nochk')) {
                    input.classList.remove('nochk');
                }else{
                    input.classList.add('nochk');
                }
            });
        });
    });
}

export default main;
